
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { AfterSaveContext, AttachmentViewModel, DocumentSearchCriteria, DocumentsSearchModel, ExecutionResult, IDocument, IDocumentEmail, KeyValue, RepositoryDataCollection, SaveAttachmentViewModel, TcmCredentials, Tuple } from "@tylertech/tyler-api-types";

/**
 * DocumentService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class DocumentService {
    constructor(private readonly $apiService: ApiService) { }
    
    AddAttachment(attachment: SaveAttachmentViewModel): Promise<ExecutionResult<string[]>> {
        return this.$apiService.sendAuth("IDocumentService/AddAttachment", attachment);
    }
    CleanupDocument(referenceId: string): Promise<void> {
        return this.$apiService.sendAuth("IDocumentService/CleanupDocument", referenceId);
    }
    DeleteAttachment(pEntity: DocumentSearchCriteria): Promise<ExecutionResult<boolean>> {
        return this.$apiService.sendAuth("IDocumentService/DeleteAttachment", pEntity);
    }
    DownloadAllDocuments(formData: RepositoryDataCollection): Promise<AfterSaveContext> {
        return this.$apiService.sendAuth("IDocumentService/DownloadAllDocuments", formData);
    }
    DownloadDocument(pEntity: DocumentSearchCriteria): Promise<ExecutionResult<IDocument>> {
        return this.$apiService.sendAuth("IDocumentService/DownloadDocument", pEntity);
    }
    EmailDocument(viewModel: IDocumentEmail): Promise<void> {
        return this.$apiService.sendAuth("IDocumentService/EmailDocument", viewModel);
    }
    GetContentManagementType(): Promise<string> {
        return this.$apiService.sendAuth("IDocumentService/GetContentManagementType");
    }
    GetDocTypes(criteria: DocumentSearchCriteria): Promise<ExecutionResult<Tuple<string, string>[]>> {
        return this.$apiService.sendAuth("IDocumentService/GetDocTypes", criteria);
    }
    GetDocument(documentId: string): Promise<number[]> {
        return this.$apiService.sendAuth("IDocumentService/GetDocument", documentId);
    }
    GetDocumentCount(pEntity: DocumentSearchCriteria): Promise<ExecutionResult<number>> {
        return this.$apiService.sendAuth("IDocumentService/GetDocumentCount", pEntity);
    }
    GetDocumentCounts(pSearchModel: DocumentsSearchModel, filterString?: string): Promise<KeyValue[]> {
        return this.$apiService.sendAuth("IDocumentService/GetDocumentCounts", pSearchModel, filterString);
    }
    GetDocumentList(pEntity: DocumentSearchCriteria): Promise<ExecutionResult<AttachmentViewModel[]>> {
        return this.$apiService.sendAuth("IDocumentService/GetDocumentList", pEntity);
    }
    GetEmailList(referenceId: string): Promise<string[]> {
        return this.$apiService.sendAuth("IDocumentService/GetEmailList", referenceId);
    }
    GetTcm(pEntity: DocumentSearchCriteria): Promise<ExecutionResult<string>> {
        return this.$apiService.sendAuth("IDocumentService/GetTcm", pEntity);
    }
    HasTcm(): Promise<ExecutionResult<boolean>> {
        return this.$apiService.sendAuth("IDocumentService/HasTcm");
    }
    OpenContentManagerInNewTab(formData: RepositoryDataCollection): Promise<AfterSaveContext> {
        return this.$apiService.sendAuth("IDocumentService/OpenContentManagerInNewTab", formData);
    }
    TestTcmLogin(login: TcmCredentials): Promise<boolean> {
        return this.$apiService.sendAuth("IDocumentService/TestTcmLogin", login);
    }
    TransferDocuments(searchCriterias: Tuple<DocumentSearchCriteria, DocumentSearchCriteria>): Promise<void> {
        return this.$apiService.sendAuth("IDocumentService/TransferDocuments", searchCriterias);
    }
}
